function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "comment_icn");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-207.000000, -23.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "comment_icn",
  transform: "translate(207.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-3",
  points: "18.0016 12.1071517 18.0016 12.6071517 7.5016 12.6071517 7.5016 12.1071517"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-2",
  points: "18.0016 9.10715167 18.0016 9.60715167 7.5016 9.60715167 7.5016 9.10715167"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-1",
  points: "18.0016 6.10715167 18.0016 6.60715167 7.5016 6.60715167 7.5016 6.10715167"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-6",
  points: "1.10943235 17.4296373 1.11023026 16.9296379 9.68572258 16.9433227 9.68492467 17.4433221"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.70482817,16.971473 C9.70482817,17.0742788 9.70482817,17.5388638 9.70482817,18.3652278 C9.70482817,19.1915919 9.70482817,20.0179559 9.70482817,20.84432 L9.20482817,20.61112 L9.20482817,16.971473 L9.70482817,16.971473 Z",
  id: "Stroke-14"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-16",
  points: "14.525966 17.0145581 14.8065812 17.428388 9.45482817 21 9.20482817 20.61112"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-12",
  points: "24.6875211 0.915217391 24.6875211 17.471473 24.1875211 17.471473 24.1875211 0.915217391"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-4",
  points: "24.4865296 0.915217391 24.4865296 1.41521739 0.913402817 1.41521739 0.913402817 0.915217391"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-10",
  points: "1.41901408 0.948161739 1.41901408 17.4299704 0.919014085 17.4299704 0.919014085 0.948161739"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-8",
  points: "24.6700789 17.0260278 24.6700789 17.5260278 14.5680507 17.5260278 14.5680507 17.0260278"
}))));

var SvgCommentIcn = function SvgCommentIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommentIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment_icn.49f3ec8f.svg";
export { ForwardRef as ReactComponent };